module.exports = __webpack_public_path__ + "static/media/logo.b654d5c4.png";